import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CyprusFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14567'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14567)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.2859 2.33337C14.5447 2.20653 14.8039 2.50527 14.6417 2.7436L14.3338 3.19628C14.3022 3.24277 14.2617 3.28253 14.2146 3.31328L12.9065 4.1679C12.8738 4.18927 12.8433 4.21381 12.8154 4.24116C12.577 4.47477 12.577 4.85862 12.8154 5.09224L12.8573 5.13337C13.1188 5.38956 13.1188 5.81051 12.8573 6.0667L12.6979 6.22298C12.508 6.409 12.2216 6.45518 11.9829 6.33824C11.6754 6.18757 11.3039 6.31138 11.1483 6.6164L11.0777 6.75479C10.9976 6.91185 10.8585 7.03077 10.6909 7.08552L9.62488 7.43374C9.55804 7.45558 9.48818 7.4667 9.41787 7.4667H8.97358C8.7269 7.4667 8.50104 7.60502 8.38893 7.82476C8.22607 8.14397 7.83728 8.27354 7.51548 8.11586L6.28718 7.51399C6.22325 7.48267 6.16475 7.4413 6.1139 7.39147L5.43549 6.72663C5.30936 6.60302 5.23828 6.43385 5.23828 6.25724V5.93816C5.23828 5.75142 5.38967 5.60003 5.57641 5.60003C5.66491 5.60003 5.74987 5.56534 5.81308 5.5034L6.47244 4.85722C6.59705 4.7351 6.76458 4.6667 6.93906 4.6667H7.14182C7.42727 4.6667 7.68105 4.48496 7.77297 4.21471L7.9078 3.8183C8.01526 3.50239 8.33973 3.31458 8.66719 3.37876L10.3322 3.70511C10.4272 3.72372 10.5251 3.72144 10.6191 3.69841L12.3111 3.28385C12.3577 3.27245 12.4028 3.25607 12.4458 3.23499L13.3335 2.80003L14.2859 2.33337Z'
					fill='#E7832C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 11.2001C10.2626 11.2001 10.4758 10.9911 10.4758 10.7334C10.4758 10.4757 10.2626 10.2667 9.99963 10.2667C9.73664 10.2667 9.52344 10.4757 9.52344 10.7334C9.52344 10.9911 9.73664 11.2001 9.99963 11.2001Z'
					fill='#445128'
				/>
				<path
					opacity='0.75'
					d='M11.4277 10.2667C11.4277 10.2667 12.8563 9.80003 13.3325 8.8667'
					stroke='#445128'
					strokeWidth='1.33333'
					strokeLinecap='round'
				/>
				<path
					opacity='0.75'
					d='M8.57227 10.2667C8.57227 10.2667 7.14369 9.80003 6.6675 8.8667'
					stroke='#445128'
					strokeWidth='1.33333'
					strokeLinecap='round'
				/>
			</g>
		</svg>
	);
};

export default CyprusFlagIcon;
